// LUMINA · pages/vajra/primitives.jsx
// Phase 39D: stateless UI primitives

import React from 'react';
import { API, CR, GD, GDB, GDL, DG, TXT, TXT2 } from './constants';

export function VajraInput({ label, value, onChange, type="text", placeholder, required, small }) {
  return (
    <div style={{marginBottom:small?8:14}}>
      <label style={{display:"block",fontSize:11,color:TXT2,letterSpacing:1.5,textTransform:"uppercase",marginBottom:4}}>
        {label}{required && <span style={{color:GD}}> *</span>}
      </label>
      <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
        required={required}
        style={{width:"100%",padding:small?"7px 10px":"9px 13px",border:`1px solid rgba(212,175,55,0.35)`,borderRadius:7,fontSize:small?13:14,background:"rgba(255,255,255,0.95)",color:TXT,boxSizing:"border-box",outline:"none"}}/>
    </div>
  );
}

export function VajraBtn({ children, onClick, disabled, variant="primary", small, type="button", style }) {
  const base = {border:"none",borderRadius:7,cursor:disabled?"default":"pointer",
    fontSize:small?12:14,letterSpacing:1,padding:small?"6px 14px":"10px 24px",
    opacity:disabled?0.5:1};
  const styles = {
    primary: {...base,background:`linear-gradient(135deg,${GD},#A07828)`,color:"#fff"},
    outline: {...base,background:"transparent",border:`1px solid ${GDB}`,color:GD},
    gold:    {...base,background:GD,color:"#fff"},
    green:   {...base,background:DG,color:"#fff"},
  };
  return <button type={type} style={{...styles[variant]||styles.primary, ...style}} onClick={onClick} disabled={disabled}>{children}</button>;
}

export function ProgressBar({ pct, color=CR }) {
  return (
    <div style={{height:6,background:"rgba(0,0,0,0.08)",borderRadius:3,overflow:"hidden"}}>
      <div style={{width:`${Math.min(pct,100)}%`,height:"100%",background:color,borderRadius:3,transition:"width .4s ease"}}/>
    </div>
  );
}

export function DynamicProofCounter({ apiBase, label, fallback = 0, suffix = "+" }) {
  const [count, setCount] = React.useState(fallback);
  const [display, setDisplay] = React.useState(0);
  React.useEffect(() => {
    if (apiBase) {
      fetch(`${apiBase}/vajra/stats`)
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d?.member_count) setCount(d.member_count); })
        .catch(() => {});
    }
  }, [apiBase, fallback]);
  React.useEffect(() => {
    let start = 0;
    const step = Math.max(1, Math.ceil(count / 40));
    const timer = setInterval(() => {
      start += step;
      if (start >= count) { setDisplay(count); clearInterval(timer); }
      else setDisplay(start);
    }, 30);
    return () => clearInterval(timer);
  }, [count]);
  return <span style={{fontVariantNumeric:"tabular-nums"}}>{display}{suffix} {label}</span>;
}

export function PaymentInfo({ ev }) {
  if (!ev.donation_type || ev.donation_type === "free") return null;
  return (
    <div style={{margin:"10px 0",padding:"10px 14px",borderRadius:8,
      background:"rgba(139,105,20,0.05)",border:"1px solid rgba(212,175,55,0.2)"}}>
      <div style={{fontSize:11,color:GD,letterSpacing:1,marginBottom:5}}>支付方式</div>
      <div style={{fontSize:12,color:TXT2,lineHeight:1.8}}>
        E-Transfer / PayPal<br/>
        <span style={{color:GD,fontWeight:500}}>canada.btf@gmail.com</span><br/>
        备注：<strong>{ev.title_zh||"法会活动"}</strong> + 您的姓名
      </div>
      {ev.donation_type==="fixed"&&ev.fee_amount&&(
        <div style={{marginTop:6,fontSize:13,color:"#7c3aed",fontWeight:500}}>
          金额：${(ev.fee_amount/100).toFixed(0)} CAD
        </div>
      )}
      {ev.donation_type==="donation"&&(
        <div style={{marginTop:6,fontSize:11,color:TXT2,fontStyle:"italic"}}>
          随喜金额由您决定，功德回向十方
        </div>
      )}
    </div>
  );
}
